export { FastFood as default } from './FastFood';
